// extracted by mini-css-extract-plugin
module.exports = {"tagArea":"style-module--tagArea--dWyra","tag":"style-module--tag--25rpm"};